import z from 'zod';
import { DateTimeSchema, objectIdRef, ObjectIdString } from '../../common.js';
import { IAtsEntity } from './atsEntitySchema.js';
import { ICandidateProfileData } from '../candidateProfileSchema.js';
import { IEmbeddingData } from '../embeddingSchema.js';
import { CorporateUser } from '../../external/bullhornSchemas/bullhornApiEntities.js';

//--------------------------------------------------------------------------------------------------------------------//
//region DB Interfaces

export const IAtsPerson = IAtsEntity.safeExtend({
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  phones: z.string().array().default([]),
  emails: z.string().array().default([]),
});
export type IAtsPerson = z.infer<typeof IAtsPerson>;

export const IRecruiter = IAtsPerson.safeExtend({
  manager: objectIdRef('Recruiter').nullish(),
  authUser: objectIdRef('AuthUser').nullish(),
  isApiUser: z.boolean().nullish(),
});
export type IRecruiter = z.infer<typeof IRecruiter>;

export const IAtsContact = IAtsPerson;
export type IAtsContact = z.infer<typeof IAtsContact>;

export const CandidateStatus = z.enum([
  'new',
  'complete',
  'processing',
  'preloadInsightsQueued',
  'prefetchActivityQueued',
  'failed',
]);
export type CandidateStatus = z.infer<typeof CandidateStatus>;

export const IAtsCandidate = IAtsPerson.safeExtend({
  status: CandidateStatus,
  error: z.string().optional(),
  profileData: ICandidateProfileData.nullish(),
  embeddingData: IEmbeddingData.nullish(),
});
export type IAtsCandidate = z.infer<typeof IAtsCandidate>;

export const IBullhornUser = IRecruiter.safeExtend({
  sessionData: z
    .object({
      sessionToken: z.string().optional(),
      lastLogin: DateTimeSchema.optional(),
      loginCount: z.number().optional(),
    })
    .optional(),
  rawData: CorporateUser,
  notificationSettings: z
    .object({
      emailAlertsEnabled: z.boolean().optional(),
      emailOverride: z.string().optional(),
      timezone: z.string().optional(),
    })
    .optional(),
});
export type IBullhornUser = z.infer<typeof IBullhornUser>;
//endregion
//--------------------------------------------------------------------------------------------------------------------//
//region DTOs

export const RecruiterDTO = z.object({
  _id: ObjectIdString,
  sourceId: z.string(),
  name: z.string().default(''),
  firstName: z.string().default(''),
  lastName: z.string().default(''),
  department: z.string().nullish(),
  authUser: ObjectIdString.nullish(),
  authUserEmail: z.string().nullish(),
  email: z.string().nullish(),
});
export type RecruiterDTO = z.infer<typeof RecruiterDTO>;

export const CandidateDTO = z.object({
  _id: ObjectIdString,
  sourceId: z.string(),
  name: z.string().default(''),
  firstName: z.string().default(''),
  lastName: z.string().default(''),
  rawData: z
    .looseObject({
      id: z.number(),
      dateAdded: DateTimeSchema.optional(),
    })
    .nullish(),
});
export type CandidateDTO = z.infer<typeof CandidateDTO>;

//endregion
//--------------------------------------------------------------------------------------------------------------------//
